import { orchestrator } from 'satcheljs';
import { initializeSharedFolderRoots, addSharedFolderUser } from '../actions/publicActions';
import getOtherMailboxConfiguration from '../services/getOtherMailboxConfiguration';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import { getAggregationBucket } from 'owa-analytics-actions';

/**
 * An orchestrator that gets all the shared folder user details and initializes the folder roots
 */
export default orchestrator(initializeSharedFolderRoots, async () => {
    const sharedFoldersUsersResponse = await getOtherMailboxConfiguration();
    const otherMailboxEntries =
        sharedFoldersUsersResponse && sharedFoldersUsersResponse.OtherMailboxEntries;
    if (otherMailboxEntries) {
        if (otherMailboxEntries.length > 0) {
            otherMailboxEntries.forEach(userInfo => {
                addSharedFolderUser(
                    userInfo.DisplayName,
                    userInfo.PrincipalSMTPAddress,
                    true /* skipServerValidation */
                );
            });
            logSharedFolderCount(otherMailboxEntries.length);
        }
    } else {
        trace.error(
            'initializeSharedFolderRoots failed with getOtherMailboxConfiguration response as : ' +
                sharedFoldersUsersResponse
        );
    }
});

/**
 * Log the Shared Folder user count on initial load.
 * @param count - number of other users the current user has added to view the shared folders
 */
function logSharedFolderCount(count: number) {
    logUsage('Triage_SharedFolders_LoadList', [getAggregationBucket({ value: count })]);
}
